import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, FileText, ReceiptEuro, Settings as Cog, LogOut, Library } from "lucide-react";

const nav = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/clients", label: "Clients", icon: Users, id: "clients" },
  { to: "/devis", label: "Devis", icon: FileText, id: "devis" },
  { to: "/factures", label: "Factures", icon: ReceiptEuro, id: "factures" },
  { to: "/bibliotheque", label: "Bibliothèque", icon: Library, id: "bibliotheque" },
  { to: "/parametres", label: "Paramètres", icon: Cog, id: "parametres" },
];

export default function Layout({ children }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col md:flex-row">
      {/* Desktop sidebar */}
      <aside className="hidden md:flex md:flex-col w-64 bg-white border-r border-slate-200 sticky top-0 h-screen">
        <div className="flex items-center gap-2 px-6 py-5 border-b border-slate-200">
          <img src="/logo.png" alt="MS ÉNERGIE" className="h-11 w-auto object-contain" />
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.id}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-md font-semibold transition-colors ${
                  isActive ? "bg-[#0284C7] text-white" : "text-slate-700 hover:bg-slate-100"
                }`
              }
            >
              <n.icon size={22} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-200">
          <div className="px-4 py-2 text-xs text-slate-500 truncate">{user?.email}</div>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-md font-semibold text-red-600 hover:bg-red-50"
          >
            <LogOut size={22} /> Déconnexion
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <header className="md:hidden sticky top-0 z-30 bg-white border-b border-slate-200 flex items-center justify-between px-4 h-14">
        <img src="/logo.png" alt="MS ÉNERGIE" className="h-8 w-auto object-contain" />
        <button data-testid="logout-button-mobile" onClick={logout} className="text-red-600 p-2">
          <LogOut size={22} />
        </button>
      </header>

      {/* Content */}
      <main className="flex-1 min-w-0 pb-20 md:pb-0">{children}</main>

      {/* Mobile bottom nav */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-slate-200 grid grid-cols-6">
        {nav.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            data-testid={`mnav-${n.id}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center py-2 text-[10px] font-semibold ${
                isActive ? "text-[#0284C7]" : "text-slate-500"
              }`
            }
          >
            <n.icon size={20} />
            {n.label.split(" ")[0]}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
